/* eslint-disable react-hooks/exhaustive-deps */
import { observer } from 'mobx-react'
import { Modal, QRCode } from 'antd'
import styles from './OpenVipModal.module.less'
import { IconImage } from '@/components/Icon/Icon'
import { useCallback, useEffect, useRef, useState } from 'react'
import { api } from '@/helpers/api'
import { commonUtils } from '@/helpers/commonUtils'
import { PayHelper } from '@/helpers/payHelper'
import classNames from 'classnames'
import { debounce } from 'lodash-es'
import { userService } from '@/services/userService'
import { observable } from 'mobx'

const store = observable({
  maxDownCount: 20,
})

export interface OpenVipModalProps {
  visible: boolean
  detail?: ServerData.PptData
  payHelper: PayHelper
  onPaySuccess?: (timeType: string) => void
  onClose: () => void
}

// 商品信息组件
const GoodsInfo = observer((props: OpenVipModalProps) => {
  const [list, setList] = useState<ServerData.PptData[]>([
    {} as ServerData.PptData,
    {} as ServerData.PptData,
    {} as ServerData.PptData,
  ])

  useEffect(() => {
    if (props.detail?.id) {
      api.ppt.getPptRecommend(props.detail.id).then((res) => {
        setList(res.dataList)
      })
    } else {
      api.ppt
        .getPptList({
          page: 1,
          pageSize: 6,
        })
        .then((res) => {
          setList(res.dataList)
        })
    }
  }, [props.detail?.id])

  return (
    <div className={classNames(styles.goodsInfo, { [styles.noDetail]: !props.detail?.id })}>
      {props.detail?.id && (
        <>
          <div className={styles.goodsInfoLeft}>
            <div className={styles.goodsInfoLeftTitle}>
              <IconImage
                className={styles.goodsInfoLeftTitleIcon}
                width={16}
                src='OpenVip_IconStar_2'
              />
              当前模版
            </div>
            <div className={styles.currentGoodsCard}>
              <div className={styles.currentGoodsCardImg}>
                <img
                  className={styles.img}
                  src={commonUtils.getimageView(props.detail?.abbreviatePath, 195, 109)}
                  alt={props.detail?.name}
                  draggable={false}
                />
              </div>
              <div className={styles.currentGoodsCardTitle}>{props.detail?.name}</div>
            </div>
          </div>
          <div
            className={styles.goodsInfoRightLine}
            style={{
              border: '1px dashed rgba(233,208,180,0.4)',
              opacity: 0.2,
            }}
          ></div>
        </>
      )}

      <div className={styles.goodsInfoRight}>
        <div className={styles.goodsInfoLeftTitle}>
          <IconImage className={styles.goodsInfoLeftTitleIcon} width={21} src='OpenVip_IconStar' />
          升级会员<span>3000+</span>动效模版任意使用
        </div>
        <div className={styles.otherGoodsCard}>
          <div
            className={styles.otherGoodsWrapper}
            style={{
              animationDuration: `${list.length * 8}s`,
            }}
          >
            {[...list, ...list].map((item, idx) => {
              return (
                <div key={`${item.id}-${idx}`} className={styles.otherGoodsCardItem}>
                  <div className={styles.otherGoodsCardItemImg}>
                    {item.abbreviatePath && (
                      <img
                        src={commonUtils.getimageView(item.abbreviatePath, 195, 109)}
                        className={styles.img}
                        alt={item.name}
                        draggable={false}
                      ></img>
                    )}
                  </div>
                  <div className={styles.otherGoodsCardItemTitle}>{item.name}</div>
                </div>
              )
            })}
          </div>
        </div>
      </div>
    </div>
  )
})

// 会员权益组件
const MemberBenefits = observer(() => {
  return (
    <div className={styles.memberBenefits}>
      <p className={styles.memberBenefitsTitle}>
        <IconImage
          className={styles.memberBenefitsTitleIcon}
          width={16}
          src='OpenVip_IconBenefits'
        />
        会员权益
      </p>
      <ul className={styles.memberBenefitsList}>
        <li className={styles.memberBenefitsListItem}>
          <IconImage width={24} src='OpenVip_IconBenefits_1' />
          3000+动态PPT素材库
        </li>
        <li className={styles.memberBenefitsListItem}>
          <IconImage width={24} src='OpenVip_IconBenefits_2' />
          每日更新最新的素材库
        </li>
        <li className={styles.memberBenefitsListItem}>
          <IconImage width={24} src='OpenVip_IconBenefits_3' />
          会员专享独家动效特权
        </li>
        <li className={styles.memberBenefitsListItem}>
          <IconImage width={24} src='OpenVip_IconBenefits_4' />
          每日任意动效{store.maxDownCount}次下载
        </li>
        <li className={styles.memberBenefitsListItem}>
          <IconImage width={24} src='OpenVip_IconBenefits_5' />
          本地的源文件自由编辑
        </li>
        <li className={styles.memberBenefitsListItem}>
          <IconImage width={24} src='OpenVip_IconBenefits_6' />
          专属客服优先支持接待
        </li>
      </ul>
    </div>
  )
})

const setTyper = (element: HTMLElement, words?: Array<string>) => {
  if (!element || !words || !Array.isArray(words) || (Array.isArray(words) && !words.length)) return

  const LETTER_TYPE_DELAY = 30
  const WORD_STAY_DELAY = 5000

  const DIRECTION_FORWARDS = 0
  const DIRECTION_BACKWARDS = 1

  let direction = DIRECTION_FORWARDS
  let wordIndex = 0
  let letterIndex = 0
  let wordTypeInterval: unknown
  let startTypingTimeout: unknown

  startTyping()

  function startTyping() {
    wordTypeInterval = setInterval(typeLetter, LETTER_TYPE_DELAY)
  }

  function typeLetter() {
    const word = words![wordIndex]

    if (direction === DIRECTION_FORWARDS) {
      letterIndex++

      if (letterIndex === word.length) {
        direction = DIRECTION_BACKWARDS
        clearInterval(wordTypeInterval as number)
        startTypingTimeout = setTimeout(startTyping, WORD_STAY_DELAY)
      }
    } else if (direction === DIRECTION_BACKWARDS) {
      letterIndex--

      if (letterIndex === 0) {
        nextWord()
      }
    }

    const textToType = word.substring(0, letterIndex)
    element.textContent = textToType
  }

  function nextWord() {
    letterIndex = 0
    direction = DIRECTION_FORWARDS
    wordIndex++

    if (wordIndex === words!.length) {
      wordIndex = 0
    }
  }

  return () => {
    startTypingTimeout && clearTimeout(startTypingTimeout as number)
    wordTypeInterval && clearInterval(wordTypeInterval as number)
  }
}

// 用户评论组件
const UserComment = observer(() => {
  const textRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    return setTyper(textRef.current as HTMLElement, [
      '学生答辩全靠它！！！连夜赶出电影级动画片头，导师看完直接给了优秀～',
      '我们电商团队每天蹲更新，上周刚下载的带货动效素材转化率直接涨了30%。',
      '我们小公司没预算也能装大牌，年会PPT动效套模板省下万元设计费，老板狂夸。',
      '这会员开的太值了！昨天给娃做的科普课件动效像迪士尼动画，全班家长追着我要制作链接哈哈哈！',
      '我们搞自媒体的真的会谢！以前剪条动态片头2小时，现在拖素材5分钟搞定，粉丝还以为我雇了团队…',
      '创业小白的救命稻草！路演PPT动效直接碾压对手，投资人当场说‘你们团队审美很在线啊’（偷笑）',
      '妈呀！临时接的婚礼快剪单子全靠这网站救场！套个模板改新人名字直接交片，新人夸我效率绝了！',
    ])
  }, [])

  return (
    <div className={styles.userComment}>
      <div className={styles.userCommentTitle}>
        <IconImage className={styles.userCommentTitleIcon} width={17} src='OpenVip_IconSearch' />
        <span>用户评论</span>
      </div>
      <div className={styles.userCommentText}>
        <div ref={textRef} className={styles.userCommentTextList}>
          {/* {[...comments, ...comments].map((item, idx) => {
            return (
              <div key={idx} className={styles.userCommentTextItem}>
                {item}
              </div>
            )
          })} */}
        </div>
      </div>
      <IconImage className={styles.userCommentIcon} src='OpenVip_IconDoubleQuote' />
      <IconImage className={styles.userCommentIcon2} src='OpenVip_IconDoubleQuote_2' />
    </div>
  )
})

// 订单信息组件
const OrderInfo = observer((props: OpenVipModalProps) => {
  const [plan, setPlan] = useState<ServerData.OrderPlan[]>([])
  const [currentPlan, setCurrentPlan] = useState<ServerData.OrderPlan>({} as ServerData.OrderPlan)
  const [chargeChannel, setChargeChannel] =
    useState<PostData.CreateOrderData['chargeChannel']>('wx_pub_qr')
  const [order, setOrder] = useState<ServerData.CreateOrderData>({} as ServerData.CreateOrderData)

  const createOrder = useCallback(
    debounce((planId, chargeChannel) => {
      props.payHelper.closePay()
      setOrder({} as ServerData.CreateOrderData)
      props.payHelper.createPayQrCode({
        planId,
        materialId: props.detail?.id,
        chargeChannel,
        onCreateOrder(data) {
          setOrder(data)
        },
        onPaySuccess(data) {
          props.onPaySuccess?.(currentPlan.timeType)
          props.onClose()
        },
      })
    }, 100),
    []
  )

  useEffect(() => {
    if (currentPlan.id && chargeChannel) {
      createOrder(currentPlan.id, chargeChannel)
    }
  }, [currentPlan, chargeChannel])

  useEffect(() => {
    if (props.visible) {
      store.maxDownCount = 20
      api.order.getPlanList().then((res) => {
        const list = res.dataList.sort((a, b) => a.price - b.price)
        setCurrentPlan(list.find((item) => item.timeType === 'year') || list[0])
        setPlan(list)
      })
    }
  }, [props.visible])

  return (
    <>
      <div className={styles.orderInfo}>
        <div className={styles.orderInfoItem} style={{ marginTop: 0 }}>
          <span className={styles.orderInfoItemLabel}>时长：</span>
          <span className={styles.planType}>
            {plan.map((item) => {
              return (
                <span
                  key={item.id}
                  className={classNames(styles.planTypeItem, {
                    [styles.active]: currentPlan.id === item.id,
                  })}
                  onClick={() => {
                    setCurrentPlan(item)
                    store.maxDownCount = item.timeType === 'year' ? 20 : 10
                  }}
                >
                  {item.timeName}
                  {item.timeType === 'year' && (
                    <div className={styles.discountTips}>低至¥0.09/个</div>
                  )}
                </span>
              )
            })}
          </span>
        </div>
        <div className={styles.orderInfoItem} style={{ marginTop: 11 }}>
          <div className={styles.orderInfoItemLabel}>支付：</div>
          <div className={styles.payType}>
            <div
              className={classNames(styles.payTypeItem, {
                [styles.active]: chargeChannel === 'wx_pub_qr',
              })}
              onClick={() => setChargeChannel('wx_pub_qr')}
            >
              <IconImage width={17} src='IconWepay'></IconImage>
              微信支付
            </div>
            <div
              className={classNames(styles.payTypeItem, {
                [styles.active]: chargeChannel === 'alipay_qr',
              })}
              onClick={() => setChargeChannel('alipay_qr')}
            >
              <IconImage width={17} height={17} src='IconAlipay'></IconImage>
              支付宝支付
            </div>
          </div>
        </div>
        <div className={styles.orderInfoItem} style={{ marginTop: 6 }}>
          <span className={styles.orderInfoItemLabel}>应付：</span>
          <span className={styles.orderInfoPrice}>
            ￥{commonUtils.parseCurrency(currentPlan.price)}
          </span>
        </div>
        <div className={styles.payTips}>
          <IconImage width={11} height={11} src='OpenVip_IconCheck' />
          开通后请在一年内及时下载，可提供发票
        </div>
      </div>
      <div className={styles.orderPayQr}>
        <QRCode
          value={order.codeUrl || '-'}
          style={{ borderRadius: 6, padding: 4 }}
          size={137}
          bgColor='#fff'
          status={order.codeUrl ? 'active' : 'loading'}
        />
      </div>
    </>
  )
})

// 主组件
const OpenVipModal = observer((props: OpenVipModalProps) => {
  return (
    <Modal
      open={props.visible}
      footer={null}
      closeIcon={false}
      onCancel={props.onClose}
      width={853}
      centered
      title={null}
      styles={{
        body: { padding: 0 },
        content: {
          padding: 0,
          overflow: 'hidden',
          backgroundColor: 'transparent',
        },
      }}
    >
      <div className={styles.openVipModal}>
        <div className={styles.modalClose} onClick={props.onClose}>
          <IconImage width={16} className={styles.closeImg} src='IconClose' />
        </div>
        <div className={styles.modalTitle}>{userService.isVip ? '续费会员' : '升级会员'}</div>
        <div className={styles.modalContent}>
          <div className={styles.goodsBox}>
            <GoodsInfo {...props} />
            <MemberBenefits />
          </div>
          <div className={styles.otherBox}>
            <UserComment />
            <div className={styles.divider}></div>
            <OrderInfo {...props} />
          </div>
        </div>
      </div>
    </Modal>
  )
})

export default OpenVipModal
